import { render, staticRenderFns } from "./AdminSellerManagement.vue?vue&type=template&id=05450c66&scoped=true"
import script from "./AdminSellerManagement.vue?vue&type=script&lang=js"
export * from "./AdminSellerManagement.vue?vue&type=script&lang=js"
import style0 from "./AdminSellerManagement.vue?vue&type=style&index=0&id=05450c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05450c66",
  null
  
)

export default component.exports